module.exports = __webpack_public_path__ + "img/UTS-Icon5_os.3b01db03.png";